module.exports = {  
    bindings: { 
        autoFocus: '<',
        cityName: '<',
        possibleCities: '<',
        selectionChanged: '&',
        validation: '<' 
    },
    controller: cityPickerController,
    templateUrl: 'geography/components/city-picker.html'
};

cityPickerController.$inject = ['$element', '$timeout'];

function cityPickerController($element, $timeout) {
    var vm = {
        $onInit: attached,
        $postLink: postLink,
        clear: clear,
        city: null,
        itemSelected: itemSelected,
        onBlur: onBlur,
        onEnter: onEnter,
    };

    return vm;

    function attached() {
        if (vm.cityName) {
            vm.city = _.find( vm.possibleCities, function(city) {
                return city.CityName === vm.CityName;
            });
        }
    }

    function postLink() {
        if (vm.autoFocus) {
            $timeout(function(){
                var rootEl = $element[0];
                var inputEl = rootEl.getElementsByClassName('js-autofocus')[0];
                inputEl.focus();
            }, 0);
        }
    }

    function clear() {
        vm.city = null;
        clearSelection();
    }

    function clearSelection() {
        if (vm.selectionChanged)
            vm.selectionChanged({ city: null });            
    }

    function onBlur() {
        if (!vm.city) {
            clearSelection();
        }
    }

    function onEnter() {
        if (!vm.city) {
            clearSelection();
        }
    }

    function itemSelected(item, model) {
        if (vm.selectionChanged)
        {
            vm.selectionChanged({ city: item });
        }

    }

}
